import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { A } from 'hookrouter';

import { getIcon } from '../shared/FormatHelpers';
import SpinLoader from '../shared/SpinLoader';
import { FILTER_ITEM_OWNER } from '../../../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';

const CancelToken = axios.CancelToken;
let cancel;

const DisplayOwner = ({ item }) => {
    const { t } = useTranslation(['dealFilterDropDown']);
    const [photo, setPhoto] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const getEmployeePhoto = async (empId) => {
        if (!empId) {
            //await new Promise((r) => setTimeout(r, 1000));
            setIsLoading(false);
            return null;
        }
        const url = `api/employee/getEmpPhoto/${empId}`;
        cancel && cancel();

        let photo;
        setIsLoading(true);
        try {
            photo = await axios
                .get(url, {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                })
                .then((response) => {
                    return response.data;
                })
                .catch((thrown) => {
                    return null;
                });
        } catch (error) {
            return null;
        }
        setIsLoading(false);

        return photo;
    };

    useEffect(() => {
        if (!item) {
            return;
        }

        const setUserPhoto = async () => {
            setPhoto(await getEmployeePhoto(item.coaEmpId));
        };

        setUserPhoto();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(item || {})]);

    if (!item) {
        return null;
    }

    let PhotoComponent;
    if (isLoading) {
        PhotoComponent = <SpinLoader isLoading />;
    } else if (photo) {
        PhotoComponent = <img src={photo} alt='Owner' />;
    } else {
        PhotoComponent = <div className='default-icon'>{getIcon('user')}</div>;
    }

    return (
        <div className='display-owner'>
            <A className='owner-photo' title={item.detailedName} href={item.link ?? '/404'}>
                {PhotoComponent}
            </A>
            <div className='owner-content'>
                <A className='owner-item' title={item.detailedName} href={item.link ?? '/404'}>
                    {item.name}
                </A>
                <div className='owner-text'>{t(FILTER_ITEM_OWNER)}</div>
            </div>
        </div>
    );
};

export default DisplayOwner;
